import { CommonModule } from '@angular/common';
import {  Component, OnInit,Input, Injectable, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbActiveModal,NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct,NgbDatepickerI18n, NgbModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
} from '@angular/forms';
import { config } from 'rxjs';
import moment from 'moment';
import { CustomLandingModule } from '../../custom-landing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ShipmentConfirmationComponent } from '../shipment-confirmation/shipment-confirmation.component';
import { I18nModule } from '@spartacus/core';
import { Router } from '@angular/router';
//import { SipmentConfirmationComponent } from '../sipment-confirmation/sipment-confirmation.component';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
    selector: 'app-shipment-edit',
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule, CustomLandingModule, NgSelectModule, I18nModule],
    templateUrl: './shipment-edit.component.html',
    styleUrl: './shipment-edit.component.scss',
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ]
})
export class ShipmentEditComponent implements OnInit{
  @Input() shipData:any;
  @Input() fromscreen: any;
  materialform: UntypedFormGroup;
  form: UntypedFormGroup;
  etaTimeInput:string;
  etsdTimeInput:string;
  etcdTimeInput:string;
  etbTimeInput:string;
  timeArray = [];
  timeStart = 0; // start time in hours;
  timeEnd = 24; // end time in hours;
  timeInterval = 10; // interval in min;
  clearenceValues=[];
  SubstartDate: NgbDate = null;
  SubstartDateEtb:NgbDate = null;
  SubstartDateEtsd: NgbDate = null;
  SubstartDateEtcd: NgbDate = null;
  SubstartDateClearence: NgbDate = null;
  checkCustomClearenceFlag:boolean = false;
  dateSelected: any;
  selectYear: any;
  selectMonth: any;
  nextMonth: any;
  preMonth: any;
  tdy: any;
  startDate: NgbDate;
  convertedDate: any;
  etaconvertedDate: any;
  etbconvertedDate:any;
  etcdconvertedDate:any;
  etsdconvertedDate:any;
 
  clearenceconvertedDate:any;
  validTimeFormatValid: boolean;
  invalidValidityTimeErr: boolean;
  //etaTimeInput: string;
  etaTime: any;
  etbTime: any;
  etcdTime: any;
  etsdTime: any;

  etaTimeErr: boolean;
  defaultTime: string;
  //shipData:any= {};
  id:any;
  //clearence:any;
  checkDischargeCompletedFlag:boolean = false;
  etbTimeErr: boolean;
  etsdTimeErr: boolean;
  etcdTimeErr: boolean;
  section:any;

  constructor(public ActiveModal: NgbActiveModal,
    private toastrService: ToastrService,
    private config: NgbDatepickerConfig,
    public formatter: NgbDateParserFormatter,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private calendar: NgbCalendar,
    private formbuilder: UntypedFormBuilder,
    public modalService: NgbModal,
    private customprofile:CustomProfileService,
    private cd:ChangeDetectorRef,
    private router: Router,
  )
  {
    this.SubstartDateEtb = calendar.getToday();
    this.SubstartDate = calendar.getToday();
    this.SubstartDateEtsd = calendar.getToday();
    this.SubstartDateEtcd = calendar.getToday();

  }
 
  ngOnInit(): void  {
    this.clearenceValues = [
      { id: 'yes', Name: 'YES' },
      { id: 'no', Name: 'NO' }
     ];
      if(this.router.url.includes('portside')){
      this.section = 'portside';
     } else if(this.router.url.includes('bondedwarehouse')){
      this.section = 'bondedwarehouse';
     }

     this.tdy = this.ngbCalendar.getToday()
     const momentObj = moment();
     this.defaultTime='17:00'

        //this.startDate = momentObj.toDate();
        this.dateSelected = momentObj.format('DD/MM/YYYY');
        for (let i = this.timeStart; i <= this.timeEnd; i++) {
            const timeString = ('0' + i).slice(-2);
            const timeStringWith0 = timeString + ':00';
            const halfTimeString = timeString + ':30';
            if (halfTimeString !== '24:30') {
                this.timeArray.push(timeStringWith0);
                this.timeArray.push(halfTimeString);
            }
        }
        //this.getDefaultData();
        console.log(this.shipData)
        
        const etaDateTemp = this.formatDate(this.shipData.eta,0);
        const etbDateTemp = this.formatDate(this.shipData.etb,0);
        const etcdDateTemp = this.formatDate(this.shipData.etcd,0);
        const etsdDateTemp = this.formatDate(this.shipData.etsd,0);
        const clearanceDateTemp = this.formatDate(this.shipData.customClearedOn,0);
        if(this.shipData.etaTime){
          this.etaTime = this.shipData.etaTime;
        }else{
          this.etaTime = this.formatDate(this.shipData.eta,1);
        }
        if(this.shipData.etbTime){
          this.etbTime = this.shipData.etbTime;
        }else{
          this.etbTime = this.formatDate(this.shipData.etb,1);        
        }
        if(this.shipData.etcdTime){
          this.etcdTime = this.shipData.etcdTime;
        }else{
          this.etcdTime = this.formatDate(this.shipData.etcd,1);        
        }

        if(this.shipData.etsdTime){
          this.etsdTime = this.shipData.etsdTime;
        }else{
          this.etsdTime = this.formatDate(this.shipData.etsd,1);          
        }
        this.checkDischargeCompletedFlag =  this.shipData.checkDischargeCompletedFlag? this.shipData.checkDischargeCompletedFlag : this.shipData.isDischarged;
        
        this.etaTimeInput = this.etaTime ? this.etaTime : this.defaultTime;
        this.etbTimeInput = this.etbTime? this.etbTime : this.defaultTime;
        this.etcdTimeInput = this.etcdTime ? this.etcdTime : this.defaultTime;
        this.etsdTimeInput = this.etsdTime ? this.etsdTime : this.defaultTime
        
        this.materialform = this.formbuilder.group({
          stockPileLocation: [ this.shipData.stockPileLocation],//,disabled: this.shipData.isDischarged==true?true:false
          clearence: [{ value: this.shipData.isCustomCleared==true?'yes':'no' }],
          //discharge: [{ value: this.checkDischargeCompletedFlag==true?'yes':'no' }],
          discharge: [{ value: this.checkDischargeCompletedFlag==true?'yes':'no' ,disabled: this.shipData.isDischarged==true?true:false}],
          etaTime: [{ value: this.etaTime}],
          etbTime: [{ value: this.etbTime }],
          etcdTime: [{ value: this.etcdTime }],
          etsdTime: [{ value: this.etsdTime }], 
          etaDate: new UntypedFormControl(this.shipData.eta ? etaDateTemp : ''),
          etbDate: new UntypedFormControl(this.shipData.etb ? etbDateTemp : ''),
          etcdDate: new UntypedFormControl(this.shipData.etcd ? etcdDateTemp : ''),
          etsdDate: new UntypedFormControl(this.shipData.etsd ? etsdDateTemp : ''),
          clearenceDate: new UntypedFormControl(this.shipData.customClearedOn ? clearanceDateTemp: ''),
          nominationNumber:[this.shipData.nominationNumber],
          nominationItemNumber:[this.shipData.nominationItemNumber],
          nominationKey:[this.shipData.nominationKey],


         
        });
        this.materialform.controls['clearenceDate'].setValue(clearanceDateTemp,{onlySelf:true})
        // if(this.checkDischargeCompletedFlag==true){
        //   this.materialform.controls['etaDate'].disable();
        //   this.materialform.controls['etbDate'].disable();
        //   this.materialform.controls['etcdDate'].disable();
        //   this.materialform.controls['etsdDate'].disable();
        // }else{
        //   this.materialform.controls['etaDate'].enable();
        //   this.materialform.controls['etbDate'].enable();
        //   this.materialform.controls['etcdDate'].enable();
        //   this.materialform.controls['etsdDate'].enable();
        // }

        this.materialform.controls['clearence'].setValue(this.shipData.isCustomCleared==true?'yes':'no'  , {onlySelf: true});
        this.materialform.controls['etaTime'].setValue( this.etaTime ? this.etaTime : this.defaultTime, {onlySelf: true});
        this.materialform.controls['etbTime'].setValue( this.etbTime ? this.etbTime: this.defaultTime, {onlySelf: true});
        this.materialform.controls['etcdTime'].setValue( this.etcdTime ? this.etcdTime: this.defaultTime, {onlySelf: true});
        this.materialform.controls['etsdTime'].setValue( this.etsdTime ? this.etsdTime : this.defaultTime, {onlySelf: true});
     
        this.defaultDate();

  }

  formatDate(date,number) {
    if(date){
      if(number==0){
        let splitdate = date.split('-')[0]
        return moment(splitdate,'DD/MM/YYYY').format('DD-MM-YYYY');
      }
      else if(number==1){
        return date.split('-')[1];
      }
    }
  }

  defaultDate() {
    let date = new Date();
    this.etaconvertedDate = this.shipData.eta?moment(this.shipData.eta,'DD/MM/YYYY').format('YYYY-MM-DD'):date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.etbconvertedDate = this.shipData.eta?moment(this.shipData.etb,'DD/MM/YYYY').format('YYYY-MM-DD'):date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.etcdconvertedDate = this.shipData.eta?moment(this.shipData.etcd,'DD/MM/YYYY').format('YYYY-MM-DD'):date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.etsdconvertedDate = this.shipData.eta?moment(this.shipData.etsd,'DD/MM/YYYY').format('YYYY-MM-DD'):date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.clearenceconvertedDate = this.shipData.customClearedOn?moment(this.shipData.customClearedOn,'DD/MM/YYYY').format('YYYY-MM-DD'):date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }

  close() {
    this.ActiveModal.close();
  }

  checkCustomClearence(flag){
    if(flag == 'no'){
      this.checkCustomClearenceFlag = false;
      this.shipData.isCustomCleared = false;

    }else{
      this.checkCustomClearenceFlag = true;
      this.shipData.isCustomCleared = true;

    }
  }

  checkDischargeCompleted(flag) {
    if (flag == 'no') {
      //this.checkDischargeCompletedFlag = false;
      this.checkDischargeCompletedFlag = false;
    } else {
      //this.checkDischargeCompletedFlag = true;
      this.checkDischargeCompletedFlag =true;
    }
  }

  setTitle(value) {
    switch (value) {
        case "Select year": return this.selectYear;
        case "Select month": return this.selectMonth;
        case "Next month": return this.nextMonth;
        case "Previous month": return this.preMonth;
        default: return;
    }
}

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for (let i = 0; i < element3.length; i++) {
        let value = element3[i].getAttribute("title");
        element3[i].setAttribute("title", this.setTitle(value));
    }

    let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
    for (let i = 0; i < element4.length; i++) {
        let value = element4[i].getAttribute("title");
        element4[i].setAttribute("title", this.setTitle(value))
    }
}
etaDateSelection(selectedDate) {
  //Validdation check to be implement here
  // this.counterOfferError = false;
  // this.counterOfferErrorValue = '';
  // this.showDateError = false;
   this.SubstartDate = selectedDate;
  // this.validityDateGreater = false;
  // this.subValidityErr = false;
  // this.todayDateGreater = false
  // this.invalidValidityTimeErr = false;

 
  if (this.SubstartDate != null) {
      this.etaconvertedDate = this.SubstartDate.year + '-' + this.checkPad(this.SubstartDate.month) + '-' + this.checkPad(this.SubstartDate.day);
      this.shipData.eta = moment(this.etaconvertedDate).format('DD/MM/YYYY') + ' - ' + this.etaTimeInput

  }
}
etbDateSelection(selectedDate){
  //Validdation check to be implement here
  // this.counterOfferError = false;
  // this.counterOfferErrorValue = '';
  // this.showDateError = false;
  this.SubstartDateEtb = selectedDate;
  // this.validityDateGreater = false;
  // this.subValidityErr = false;
  // this.todayDateGreater = false
  // this.invalidValidityTimeErr = false;

 
  if (this.SubstartDateEtb != null) {
      this.etbconvertedDate = this.SubstartDateEtb.year + '-' + this.checkPad(this.SubstartDateEtb.month) + '-' + this.checkPad(this.SubstartDateEtb.day);
      this.shipData.etb = moment(this.etbconvertedDate).format('DD/MM/YYYY') + ' - ' + this.etbTimeInput

  }
}

etsdDateSelection(selectedDate){
  //Validdation check to be implement here
  // this.counterOfferError = false;
  // this.counterOfferErrorValue = '';
  // this.showDateError = false;
  this.SubstartDateEtsd = selectedDate;
  // this.validityDateGreater = false;
  // this.subValidityErr = false;
  // this.todayDateGreater = false
  // this.invalidValidityTimeErr = false;

 
  if (this.SubstartDateEtsd != null) {
      this.etsdconvertedDate = this.SubstartDateEtsd.year + '-' + this.checkPad(this.SubstartDateEtsd.month) + '-' + this.checkPad(this.SubstartDateEtsd.day);
      this.shipData.etsd = moment(this.etsdconvertedDate).format('DD/MM/YYYY') + ' - ' + this.etsdTimeInput

  }
}

etcdDateSelection(selectedDate){
  //Validdation check to be implement here
  // this.counterOfferError = false;
  // this.counterOfferErrorValue = '';
  // this.showDateError = false;
  this.SubstartDateEtcd = selectedDate;
  // this.validityDateGreater = false;
  // this.subValidityErr = false;
  // this.todayDateGreater = false
  // this.invalidValidityTimeErr = false;

 
  if (this.SubstartDateEtcd != null) {
      this.etcdconvertedDate = this.SubstartDateEtcd.year + '-' + this.checkPad(this.SubstartDateEtcd.month) + '-' + this.checkPad(this.SubstartDateEtcd.day);
      this.shipData.etcd = moment(this.etcdconvertedDate).format('DD/MM/YYYY') + ' - ' + this.etcdTimeInput

  }
}
clearenceDateSelection(selectedDate){
 //Validdation check to be implement here
  // this.counterOfferError = false;
  // this.counterOfferErrorValue = '';
  // this.showDateError = false;
  this.SubstartDateClearence = selectedDate;
  // this.validityDateGreater = false;
  // this.subValidityErr = false;
  // this.todayDateGreater = false
  // this.invalidValidityTimeErr = false;

  if (this.SubstartDateClearence != null) {
    this.clearenceconvertedDate = this.SubstartDateClearence.year + '-' + this.checkPad(this.SubstartDateClearence.month) + '-' + this.checkPad(this.SubstartDateClearence.day);
    this.shipData.customClearedOn = moment(this.clearenceconvertedDate).format('DD/MM/YYYY') ;
  }
}

checkPad(d) {
  return (d < 10) ? '0' + d.toString() : d?.toString();
}
// get today() {
//   return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
// }
  changeEtaTime(event){
    let etaTime = event.target.value;
    this.validityTimeFormatValidation(etaTime);
    this.invalidValidityTimeErr = false;
    this.etaTimeInput = etaTime;
    this.etaTime = etaTime;
    this.shipData.etaTime =etaTime;
    if(this.etaTimeInput == null || this.etaTimeInput == ""){
        this.etaTime = null; 
    } 
    this.etaTimeErr = false;
    // this.counterOfferError = false;
    // this.counterOfferErrorValue = '';
  }
  changeEtsdTime(event){
    let etsdTime = event.target.value;
    this.validityTimeFormatValidation(etsdTime);
    this.invalidValidityTimeErr = false;
    this.etsdTimeInput = etsdTime;
    this.etsdTime = etsdTime;
    this.shipData.etsdTime = etsdTime;
    if(this.etsdTimeInput == null || this.etsdTimeInput == ""){
        this.etsdTime = null; 
    } 
    this.etsdTimeErr = false;
    // this.counterOfferError = false;
    // this.counterOfferErrorValue = '';
  }
  changeEtcdTime(event){
    let etcdTime = event.target.value;
    this.validityTimeFormatValidation(etcdTime);
    this.invalidValidityTimeErr = false;
    this.etcdTimeInput = etcdTime;
    this.etcdTime = etcdTime;
    this.shipData.etcdTime = etcdTime;
    if(this.etcdTimeInput == null || this.etcdTimeInput == ""){
        this.etcdTime = null; 
    } 
    this.etcdTimeErr = false;
    // this.counterOfferError = false;
    // this.counterOfferErrorValue = '';
  }
  changeEtbTime(event){
    let etbTime = event.target.value;
    this.validityTimeFormatValidation(etbTime);
    this.invalidValidityTimeErr = false;
    this.etbTimeInput = etbTime;
    this.etbTime = etbTime;
    this.shipData.etbTime =etbTime;
    if(this.etbTimeInput == null || this.etbTimeInput == ""){
        this.etbTime = null; 
    } 
    this.etbTimeErr = false;
    // this.counterOfferError = false;
    // this.counterOfferErrorValue = '';
  }

  validityTimeFormatValidation(time){
      let regex = new RegExp(/^([01]\d|2[0-3]):?([0-5]\d)$/);
      if (regex.test(time) == true) {
          this.validTimeFormatValid = false;
      }
      else {
          this.validTimeFormatValid = true;
      }
  }

  goToNext() {
    this.shipData.checkDischargeCompletedFlag = this.checkDischargeCompletedFlag;
    let converteddates = new Object({
      etcdconvertedDate:this.etcdconvertedDate,
      etsdconvertedDate:this.etsdconvertedDate,
      etaconvertedDate:this.etaconvertedDate,
      etbconvertedDate:this.etbconvertedDate,
      clearenceconvertedDate:this.clearenceconvertedDate
        })
        console.log('data-->',this.shipData);
    const ModalRef = this.modalService.open(ShipmentConfirmationComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.shipData = {...this.materialform.value,...this.shipData};
    ModalRef.componentInstance.shipData.stockPileLocation = this.materialform.controls['stockPileLocation'].value;
    ModalRef.componentInstance.converteddates = converteddates 
    ModalRef.componentInstance.checkDischargeCompletedFlag = this.checkDischargeCompletedFlag;
    ModalRef.componentInstance.fromscreen = this.fromscreen

    ModalRef.result.then(data => {
      if (data) {
        this.shipData = data
      }
    })
    this.close();
  }

}
